import { Box, List, Stack } from "@mantine/core";
import style from "./privacy.module.css";
import { useTranslation } from "react-i18next";
import { PrivacyMenu } from "./privacy-menu";

export const ResponsibleReportingPage = () => {
    const { t } = useTranslation(["privacy"]);
    
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack className={style.menuContent} spacing={"0.5rem"} mt={"10rem"}>
                        <PrivacyMenu />
                    </Stack>

                    <Box className={style.textContent} spacing={"0.5rem"} mt={"8rem"}>
                        <article>
                            <h1 className={style.header1}>{t("responsible_reporting.title")}</h1>

                            <p>{t("responsible_reporting.intro")}</p>

                            <br />
                            <h2 className={style.header2}>{t("responsible_reporting.disclosure_title")}</h2>
                            <p>{t("responsible_reporting.disclosure_text")}</p>

                            <br />
                            <h2 className={style.header2}>{t("responsible_reporting.acknowledgement_title")}</h2>
                            <p>{t("responsible_reporting.acknowledgement_text")}</p>
                            <br />
                            <h2 className={style.header2}>{t("responsible_reporting.scope_title")}</h2>

                            <p>{t("responsible_reporting.in_scope")}</p>
                            <List>
                                {t("responsible_reporting.in_scope_list", { returnObjects: true }).map((item, index) => (
                                    <List.Item key={index}>
                                        <p>{item}</p>
                                    </List.Item>
                                ))}
                            </List>
                            <br/>

                            <p>{t("responsible_reporting.out_of_scope")}</p>
                            <List>
                                {t("responsible_reporting.out_of_scope_list", { returnObjects: true }).map((item, index) => (
                                    <List.Item key={index}>
                                        <p>{item}</p>
                                    </List.Item>
                                ))}
                            </List>
                        </article>
                    </Box>
                </div>
            </div>
        </div>
    );
};
